<dx-select-box [dataSource]="dataSource"
               [value]="team"
               (valueChange)="onTeamChange($event)"
               displayExpr="name">
    <div *dxTemplate="let item of 'item'">
        @if (item.teamId) {
            <adapt-link-team [team]="item"
                             [showIcon]="true"
                             [adaptLinkDisabled]="true"></adapt-link-team>
        } @else {
            {{ item.name }}
        }
    </div>
</dx-select-box>
